import { CaseListItem } from 'queries/cases/types';
import React from 'react';
import './style.scss';
import { useTranslation } from 'react-i18next';
import PdfCasesSummaryItem from './PdfCasesSummaryItem';
interface PdfCasesSummaryItemProps {
  cases: CaseListItem[];
}
export const CASE_ITEM_FIELDS = ['name', 'severity', 'discipline', 'status'] as Array<
  keyof Omit<CaseListItem, 'asset' | 'actions' | 'children' | 'external_reference_summary'>
>;

const PdfCasesSummaryItens: React.FC<PdfCasesSummaryItemProps> = ({ cases }) => {
  const { t } = useTranslation();
  return (
    <div className="pdf-cases-summary">
      {cases.length === 0 && (
        <div className="pdf-cases-summary-line pdf-cases-summary-line-normal ">
          <span className="pdf-cases-summary-cell">{t('pdf:normal')}</span>
        </div>
      )}
      {cases.map((caseItem) => (
        <PdfCasesSummaryItem caseItem={caseItem} />
      ))}
    </div>
  );
};

export default PdfCasesSummaryItens;
